import { AUTH, AUTH_FAIL, GET_BUSINESSEMAIL, GET_LOCATIONS, GET_STAFF, LOGOUT, GET_CURRENCY, SET_LOCATIONS } from '../action.type';
const intialState = {
  authUser: null,
  buisnessEmails: null,
  locations: null,
  locationData: null,
  staffInfo: null,
  currency: null,
  error: null
};

export const authReducer = (state = intialState, action) => {
  switch (action.type) {
    case AUTH:
      return {
        ...state,
        authUser: action.payload,
      };
    case GET_BUSINESSEMAIL:
      return {
        ...state,
        buisnessEmails: action.payload,
      };
    case GET_LOCATIONS:
      return {
        ...state,
        locations: action.payload,
      };
    case SET_LOCATIONS:
      return {
        ...state,
        locationData: action.payload,
      };
    case GET_STAFF:
      return {
        ...state,
        staffInfo: action.payload,
      };
    case GET_CURRENCY:
      return {
        ...state,
        currency: action.payload,
      };
    case AUTH_FAIL:
      return {
        ...state,
        authUser: null,
        error: action.payload
      }
    case LOGOUT:
      return intialState;
      
    default:
      return state;
  }
};
